export default __webpack_public_path__ + "static/media/centro.aa4cb416.png";